import React, { useEffect, useRef } from 'react';
import './OurPartners.scss';
import partnerInformatika from '../Assets/Images/partner-informatika.png';
import partnerShoppster from '../Assets/Images/partner-shoppster.png';
import partnerEPS from '../Assets/Images/partner-eps.png';
import partnerFKV from '../Assets/Images/partner-fkv.png';
import partnerCOK from '../Assets/Images/partner-cok.png';
import partnerMTS from '../Assets/Images/partner-mts.png';
import partnerEMS from '../Assets/Images/partner-ems.png';
import partnerBeograd from '../Assets/Images/partner-beograd.png';
import partnerTessa from '../Assets/Images/partner-tessa.png';
import partnerWSO from '../Assets/Images/partner-wso.png';
import partnerCrayon from '../Assets/Images/partner-crayon.png';
import partnerDelfi from '../Assets/Images/partner-delfi.png';
import partnerGDS from '../Assets/Images/partner-gds.png';
import partnerHSData from '../Assets/Images/partner-hsdata.png';
import partnerOTPBank from '../Assets/Images/partner-otpbank.png';
import partnerSinerga from '../Assets/Images/partner-sinerga.png';
import partnerZavodZaSport from '../Assets/Images/partner-zavodzasport.png';
import partnerMozzartBet from '../Assets/Images/partner-mozzartbet.svg';
import partnerAikBank from '../Assets/Images/partner-aikbank.png';
import partnerBigBang from '../Assets/Images/partner-bigbang.png';
import partnerEPlaneta from '../Assets/Images/partner-eplaneta.png';
import partnerEUprava from '../Assets/Images/partner-euprava.png';
import partnerGames from '../Assets/Images/partner-games.png';
import partnerMinistarstvoPravde from '../Assets/Images/partner-ministarstvopravde.png';
import partnerPlanetaSport from '../Assets/Images/partner-planetasport.png';
import partnerRZS from '../Assets/Images/partner-rzs.png';
import partnerMicrosoft from '../Assets/Images/partner-microsoft.webp';
import partnerCTShop from '../Assets/Images/partner-ctshop.png';

const partners = [
  { src: partnerMTS, alt: 'MTS' },
  { src: partnerEPS, alt: 'EPS' },
  { src: partnerEMS, alt: 'Elektromreža Srbije' },
  { src: partnerInformatika, alt: 'Informatika' },
  { src: partnerShoppster, alt: 'Shoppster' },
  { src: partnerFKV, alt: 'FK Vojvodina' },
  { src: partnerCOK, alt: 'Crnogorski olimpijski komitet', imgStyle: { maxHeight: '110px', maxWidth: '220px' } },
  { src: partnerBeograd, alt: 'Grad Beograd' },
  { src: partnerTessa, alt: 'Tessa Group' },
  { src: partnerWSO, alt: 'Wiener Städtische' },
  { src: partnerCrayon, alt: 'Crayon' },
  { src: partnerDelfi, alt: 'Delfi' },
  { src: partnerGDS, alt: 'GDS' },
  { src: partnerHSData, alt: 'HS Data', imgStyle: { maxHeight: '110px', maxWidth: '220px' } },
  { src: partnerOTPBank, alt: 'OTP Banka' },
  { src: partnerSinerga, alt: 'Sinerga' },
  { src: partnerZavodZaSport, alt: 'Zavod za sport' },
  { src: partnerMozzartBet, alt: 'Mozzart Bet' },
  { src: partnerAikBank, alt: 'AIK Banka' },
  { src: partnerBigBang, alt: 'Big Bang', imgStyle: { maxHeight: '110px', maxWidth: '220px' } },
  { src: partnerEPlaneta, alt: 'ePlaneta', imgStyle: { maxHeight: '110px', maxWidth: '220px' } },
  { src: partnerEUprava, alt: 'eUprava' },
  { src: partnerGames, alt: 'GameS' },
  { src: partnerMinistarstvoPravde, alt: 'Ministarstvo pravde' },
  { src: partnerPlanetaSport, alt: 'Planeta Sport' },
  { src: partnerRZS, alt: 'Republički zavod za statistiku' },
  { src: partnerMicrosoft, alt: 'Microsoft' },
  { src: partnerCTShop, alt: 'CT Shop' },
];

function OurPartners() {
  const trackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    // Safari sometimes leaves the transform-animated track unpainted until a reflow
    // (e.g. on scroll). Forcing a restart right after mount avoids the blank/frozen state.
    track.style.animation = 'none';
    requestAnimationFrame(() => {
      track.style.animation = '';
    });
  }, []);

  return (
    <section className='our-partners'>
      <div className='partners-header'>
        <h2 className='partners-title'>Our Customers and Partners</h2>
      </div>

      <div className='partners-marquee-wrapper'>
        <div className='partners-marquee-track' ref={trackRef}>
          {[...partners, ...partners].map((partner, index) => (
            <div className='partner-logo-item' key={index}>
              <img src={partner.src} alt={partner.alt} style={partner.imgStyle} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OurPartners;
